var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7C7C7C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 0C1.46 0 0 1.431 0 3.187v5.625C0 10.57 1.46 12 3.25 12h6.5C11.54 12 13 10.569 13 8.812V3.187C13 1.431 11.54 0 9.75 0h-6.5zm0 1.125h6.5c1.175 0 2.103.91 2.103 2.062v5.625c0 1.153-.928 2.063-2.103 2.063h-6.5c-1.175 0-2.103-.91-2.103-2.063V3.187c0-1.152.928-2.062 2.103-2.062zM4.744 3c-.303.019-.539.265-.538.562v4.875c0 .298.235.544.538.563.114.008.229-.019.328-.076l4.206-2.438c.174-.101.28-.285.28-.483s-.106-.382-.28-.483L5.072 3.082c-.098-.06-.213-.088-.328-.082zm.609 1.553L7.856 6 5.353 7.453v-2.9z",
    transform: "translate(-626 -254) translate(626 254)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.601160d8.svg";
export { ForwardRef as ReactComponent };